export const PRICE_FROM = 199;

export const OFFER = {
  name: "Custom Website",
  price: 199,
  badge: "One Flat Price",
  blurb:
    "A complete, expertly developed business website — designed, built and launched for you. No templates, no hourly billing, no surprises.",
  features: [
    "Bespoke design — no templates",
    "Expertly developed, fast-loading build",
    "Mobile-first on every screen",
    "On-page SEO setup",
    "Contact & quote forms included",
    "Analytics connected",
    "Launched on your domain in under a business week",
    "Fully managed — hosting and security handled",
  ],
};

export const SERVICES = [
  { icon: "PenTool", title: "Brand-First Design", desc: "Custom design systems built around your brand — no templates, no page-builder sameness." },
  { icon: "Code2", title: "Expert Development", desc: "Expertly developed, production-grade code that loads fast, ranks well and scales with you." },
  { icon: "Gauge", title: "High-Speed Performance", desc: "Sub-second loads, optimized assets and Core Web Vitals in the green, guaranteed." },
  { icon: "Search", title: "SEO Architecture", desc: "Semantic structure, metadata and local SEO baked in from the first commit." },
  { icon: "Smartphone", title: "Mobile-First Builds", desc: "Pixel-perfect on every screen — over 60% of your visitors are on a phone." },
  { icon: "ShieldCheck", title: "Support After Launch", desc: "Need a change later? We're one email away — we get back fast and handle it quickly." },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Discovery & Strategy", desc: "We learn your business, your customers and your goals — then map a site that sells for you." },
  { num: "02", title: "High-Impact Design", desc: "You review real designs, not wireframe promises. We refine until it feels unmistakably yours." },
  { num: "03", title: "Build & Launch", desc: "Expertly developed, tested on every device, connected to your domain and launched — typically in less than a business week." },
  { num: "04", title: "Launch & Beyond", desc: "Your site goes live on your domain — and we stay one email away whenever you need a change." },
];

export const FAQS = [
  {
    q: "How do we get started?",
    a: "Book a free call — dial (507) 841-1801 or send us a message. We'll talk through your business, what your website needs to do and exactly how we'd approach it. No pressure, no obligation.",
  },
  {
    q: "How much does a website cost?",
    a: "Every project is different, so we talk it through on your intro call first and give you a clear, fixed price before any work begins. No hourly billing, ever.",
  },
  {
    q: "How long until my site is live?",
    a: "Most sites launch in less than a business week once we have your content and brand assets. Larger builds get a clear timeline up front.",
  },
  {
    q: "What if I need changes after launch?",
    a: "Just send us a message. Text swaps, new photos, extra pages — we get back to you within one business day and handle it quickly.",
  },
  {
    q: "What do you need from me?",
    a: "Your logo, brand colors and any text or photos you have. Missing something? We'll help you create it during the design phase.",
  },
  {
    q: "Is the payment secure?",
    a: "Yes. All payments are processed by Stripe over encrypted connections. G-Studio never sees or stores your card details.",
  },
  {
    q: "What if I don't like the first design?",
    a: "We revise it with you until it feels right — revisions are always included. And if you cancel before design work begins, you get a full refund.",
  },
];

export const IMAGES = {
  workspace: "https://images.unsplash.com/photo-1483058712412-4245e9b90334?auto=format&fit=crop&w=940&q=80",
  team: "https://images.pexels.com/photos/39190477/pexels-photo-39190477.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
